"use strict";
/* eslint @typescript-eslint/no-unused-expressions:"off" */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareCategoryByURL = exports.api = exports.initApi = void 0;
var global_1 = require("@mail-core/logger/global");
var keeper_1 = require("@perf-tools/keeper");
var metrics_api_parse_status_1 = require("./metrics.api.parse-status");
var _init = {
    parseStatus: metrics_api_parse_status_1.axiosRpcLike,
};
var ERR_RULE = {
    tag: global_1.Tag.API,
    category: '5XX',
    silent: true,
    log: true,
};
function initApi(init) {
    if (init) {
        _init = __assign(__assign({}, _init), init);
    }
}
exports.initApi = initApi;
function api(req, extra) {
    if (extra === void 0) { extra = {}; }
    var err = extra.error;
    var dur = extra.duration || 1;
    var url = extra.url;
    var category = extra.category;
    var respLen = extra.responseLength;
    var readyState = 0;
    var status = extra.status || 'unk';
    var apiStatus = extra.apiStatus || status;
    if (typeof req === 'object') {
        var xhr_1 = ('xhr' in req && req.xhr) ||
            ('request' in req && req.request) ||
            ('status' in req && 'readyState' in req && req);
        // JSSDK
        if ('duration' in req) {
            dur = req.duration || dur;
        }
        // RPC/Axios: API Status
        if ('status' in req) {
            status = req.status;
            apiStatus = status;
        }
        // Response Like
        if ('ok' in req) {
            readyState = 4;
        }
        // XHR Like
        if (xhr_1) {
            status = xhr_1.status || status;
            readyState = xhr_1.readyState || readyState;
            respLen = getRespLen(xhr_1);
            url = url || xhr_1.responseURL;
        }
        // Fetch: URL
        if ('url' in req) {
            url = url || req.url;
        }
        apiStatus = _init.parseStatus(req) || apiStatus;
        // Логирование ошибок
        if (extra.log5XX && (status >= 500 || apiStatus >= 500)) {
            var http = "[HTTP] " + (xhr_1 ? xhr_1.status + " " + xhr_1.statusText : 'No XHR');
            var apiErr = new Error(status >= 500 ? http : "[API] " + apiStatus + " (" + http + ")");
            apiErr.source = url;
            apiErr.stack = ''; // стек нам тут не нужен
            try {
                global_1.coreLoggerDispatchError(apiErr, {
                    sender: 'api',
                    url: url,
                    status: status,
                    apiStatus: apiStatus,
                    headers: xhr_1 &&
                        [
                            'content-type',
                            'date',
                            'x-host',
                            'x-request-id',
                            'x-mru-json-status',
                            'x-mru-request-id',
                        ].reduce(function (map, key) {
                            map[key] = xhr_1.getResponseHeader(key);
                            return map;
                        }, {}),
                    response: getRespText(xhr_1).slice(0, 140),
                }, ERR_RULE);
            }
            catch (err) {
                global_1.coreLoggerDispatchError(err, apiErr, { category: 'api', tag: global_1.Tag.Core });
            }
        }
    }
    else {
        status = req;
        apiStatus = extra.apiStatus || status;
    }
    // By Category / Endpoint
    var api = keeper_1.system.group('pk-api', 0, true);
    var add = api.add;
    var prefix = "x-" + (category !== false ? prepareCategoryByURL(url) : category || 'unk');
    // 0. HIT by category (required)
    add(prefix + "-hit", 0, dur);
    // 1. XHR Ready State (optional)
    readyState !== 4 && add(prefix + "-r_" + reqReadyStateType(readyState), 0, dur);
    // 2. Response Length (only > 0)
    respLen && add(prefix + "-l_" + respLenType(respLen), 0, respLen);
    // 3. HTTP Status (required)
    add(prefix + "-h_" + status, 0, dur);
    // 4. API/RPC Status (only if HTTP OK)
    status >= 200 && status < 300 && add(prefix + "-a_" + apiStatus, 0, dur);
    // 5. Slow Request (only > 3s)
    dur > 3e3 && add(prefix + "-s_" + reqScore(dur), 0, dur);
    // 6. Error type (optional)
    err && add(prefix + "-e_" + ((err instanceof Error && err.name) || err), 0, dur);
    api.stop(dur);
}
exports.api = api;
var R_URL_CLEAN = /^(https?:)?\/\/.*?\/+|\/*\?+.+|^\/|api\/+v1\/+/gi;
var R_URL_NORM = /[^%.a-z\d-]+/g;
var R_URL_API_NORM = /^api_v(\d)/g;
var R_URL_API_PERL = /\/*cgi-bin/g;
var R_URL_API_GOLANG = /golang/g;
var R_ID_LIKE = /(^|\/)(\d+|(?:\d|[a-z]+\d)[\da-z]{2,})(?=\/|$)/g;
var R_UID_LIKE = /(^|\/)([0-9-a-f]{2,}-[0-9-a-f-]+)(?=\/|$)/g;
var R_SLUG_LIKE = /(_u?id){2,}|%[%a-z\d._]+/g;
var R_GRAPHQL = /graphql/g;
var CATEGORY_MAX_LEN = 24; // 32 - ('x-'.length + '-h_'.length + apiStatus.length);
function prepareCategoryByURL(url) {
    var cat = url
        ? url
            .toLowerCase()
            .replace(R_URL_CLEAN, '')
            .replace(R_URL_API_PERL, 'pl')
            .replace(R_UID_LIKE, '$1uid')
            .replace(R_ID_LIKE, '$1id')
            .replace(R_URL_NORM, '_')
            .replace(R_URL_API_NORM, 'v$1')
            .replace(R_URL_API_GOLANG, 'go')
            .replace(R_GRAPHQL, 'gql')
            .replace(R_SLUG_LIKE, '_id')
        : 'unk';
    if (cat.length > CATEGORY_MAX_LEN) {
        cat = cat.replace(/([^_]{3,})/g, function (_, slug) {
            return slug
                .replace(/-/.test(slug) ? /-([a-z])[a-z]*/g : /([^/-])[aeiou]+/g, '$1')
                .replace(/([^aeiou])(\1+)/, '$1');
        });
    }
    return cat.slice(0, CATEGORY_MAX_LEN).replace(/[_-]+/g, '_');
}
exports.prepareCategoryByURL = prepareCategoryByURL;
function getRespText(xhr) {
    var isText = xhr && (!xhr.responseType || xhr.responseType === 'text');
    return (isText && xhr.responseText) || '';
}
function getRespLen(xhr) {
    var len;
    var txt;
    if (xhr) {
        txt = getRespText(xhr);
        try {
            len = txt.length || +xhr.getResponseHeader('content-length') || 0;
        }
        catch (_a) { }
    }
    return len;
}
// 0-1 | 1-5 | 5-10 | 10-25 | 25-50 | 50-100 | 100-200 | 200-500 | 500+
//   1 |   5 |   10 |    25 |    50 |    100 |     200 |     500 | max
function respLenType(len) {
    var KiB = 1024;
    var type = 'zero';
    if (len == null) {
        type = 'unk';
    }
    else if (len > 0 && len <= KiB) {
        type = 1;
    }
    else if (len > KiB && len <= 5 * KiB) {
        type = 5;
    }
    else if (len > 5 * KiB && len <= 10 * KiB) {
        type = 10;
    }
    else if (len > 10 * KiB && len <= 25 * KiB) {
        type = 25;
    }
    else if (len > 25 * KiB && len <= 50 * KiB) {
        type = 50;
    }
    else if (len > 50 * KiB && len <= 100 * KiB) {
        type = 100;
    }
    else if (len > 100 * KiB && len <= 200 * KiB) {
        type = 200;
    }
    else if (len > 200 * KiB && len <= 500 * KiB) {
        type = 500;
    }
    else if (len > 500 * KiB) {
        type = 'max';
    }
    return type === 0 ? 'zero' : type;
}
function reqReadyStateType(state) {
    return state === 0
        ? 'unset'
        : state === 1
            ? 'open'
            : state === 2
                ? 'headers'
                : state === 3
                    ? 'loading'
                    : state === 4
                        ? 'done'
                        : 'unk';
}
function reqScore(dur) {
    return dur <= 5e3
        ? '5s'
        : dur <= 1e4
            ? "10s"
            : dur <= 3e4
                ? "30s"
                : dur <= 3e5
                    ? Math.ceil(dur / 6e4) + "m"
                    : 'max';
}
//# sourceMappingURL=metrics.api.js.map